klaviyo.init({
    account: 'SVbprT',
    platform: 'shopify',
  });
  klaviyo.enable('backinstock', {
    trigger: {
      product_page_text: window.klaviyo_bis.product_page_text,
      product_page_class: 'button button--full-width',
      product_page_text_align: 'center',
      product_page_margin: '0px',
      // alternate_anchor: "variant-item__sold-out",
      // replace_anchor: false,
    },
    modal: {
      headline: '{product_name}',
      subscribe_checked: true,
      newsletter_subscribe_label: window.klaviyo_bis.newsletter_subscribe_label,
      body_content: window.klaviyo_bis.body_content,
      email_field_label: window.klaviyo_bis.email_field_label,
      button_label: window.klaviyo_bis.button_label,
      subscription_success_label: window.klaviyo_bis.subscription_success_label,
      footer_content: window.klaviyo_bis.footer_content,
      drop_background_color: '#000',
      background_color: '#fff',
      text_color: '#000',
      button_text_color: '#ffffff',
      button_background_color: '#004570',
      close_button_color: '#000',
      error_background_color: '#004570',
      error_text_color: '#ffffff',
      success_background_color: '#004570',
      success_text_color: '#ffffff',

      // additional_styles: "@import url('https://cdn.shopify.com/s/files/1/0280/1244/5769/files/klaviyo-css.css?v=1730247136');",
      font_family: '"Harmonia Sans", sans-serif;',
      headers_font_family: '"Harmonia Sans", sans-serif;'
    },
  });